import { render, staticRenderFns } from "./OnTakeNote.vue?vue&type=template&id=eb5470ee"
import script from "./OnTakeNote.vue?vue&type=script&lang=js"
export * from "./OnTakeNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports